import React from 'react'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

import {StyledListItem} from '../commonStyles'

interface Props {
  onClick?: () => void | null
}

export const ShareYourFeedbackLink = ({onClick}: Props) => {
  if (!onClick) return null

  return (
    <StyledListItem
      as="button"
      hasDivider
      onClick={onClick}
      prefix={<Icon name="Pencil" />}
      title={
        <Text variant="labelM">
          <FormattedMessageWrapper
            id="shareYourFeedback"
            defaultMessage="Share your feedback"
          />
        </Text>
      }
      suffix={<Icon name="ChevronRight" hasMirror />}
    />
  )
}
